Vendd.Scripts.load(function () {

    var $wrapper = $('.x-store-locator'),
            $form, $stores, $map,
            $submitButton, $resetButton,
            currentState, state,
            wrapper, form, stores, map;

    var formmodel = null;
    var storemodel = null;

    var run = function () {

        if ($wrapper.length < 1)
            return false;

        $form = $('.x-store-locator-form', $wrapper);
        $stores = $('.x-store-locator-stores', $wrapper);
        $map = $('.x-google-map', $wrapper);

        wrapper = $wrapper.get(0);
        form = $form.get(0);
        stores = $stores.get(0);
        map = $map.get(0);

        if (typeof form == 'undefined')
            return false;

        currentState = {
            languageId: $wrapper.data('language-id'),
            continent: $('select[name="continent"]', $form).length > 0 ? $('select[name="continent"]', $form).val() : '',
            country: $('select[name="country"]', $form).length > 0 ? $('select[name="country"]', $form).val() : '',
            city: $('select[name="city"]', $form).length > 0 ? $('select[name="city"]', $form).val() : '',
            area: $('select[name="area"]', $form).length > 0 ? $('select[name="area"]', $form).val() : '',
            type: $('input[name="type"]', $form).length > 0 ? $('input[name="type"]:checked', $form).val() : 0,
            postalCode: $('input[name="postalCode"]', $form).length > 0 ? $('input[name="postalCode"]', $form).val() : '',
            search: $('input[name="search"]', $form).val()
        };
        state = $.extend(true, {}, currentState);

        Vendd.Store.Controller.initState(currentState);

        form.loading = function (loading) {
            if (loading) {
                $form.addClass('x-loading');
            } else {
                $form.removeClass('x-loading');
            };
        };

        form.reset = function () {
            document.location = document.location;
        };

        form.submit = function () {
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Store.Messages.Refine(currentState));
        };

        form.propButton = function () {
            if (_.isEqual(currentState, state)) {
                $submitButton.addClass('disabled').prop('disabled', true);
            } else {
                $submitButton.removeClass('disabled').prop('disabled', false);
            };
        };

        form.bind = function () {
            $submitButton = $('.js-submit', $form);
            $resetButton = $('.js-reset', $form);

            form.propButton();
        };

        form.update = function () {
            var html = Vendd.Handlebars.parse("storeLocatorForm", formmodel);

            $form.html(html);

            form.bind();

            var newState = Vendd.Store.Controller.getState();

            currentState.country = newState.country;
            currentState.city = newState.city;
            currentState.area = newState.area;
            currentState.type = newState.type;
            //$('.x-store-locator .form-row .select-wrapper select').sSelect();
            $(".newList", $wrapper).mCustomScrollbar({
                scrollbarPosition: "outside",
                scrollInertia: 400,
                theme: "dark-2",
                mouseWheel: { preventDefault: true }
            });

            form.loading(false);

            $('.x-store-locator-form select[name="city"]').change(function (e) {
                form.loading(true);

                var city = $(this).val();

                currentState.city = city;

                Vendd.MessageBus.publishAsync(wrapper, new Vendd.Store.Messages.SetCity(city));

            });

            $('.x-store-locator-form select[name="area"]').change(function (e) {
                form.loading(true);

                var area = $(this).val();

                currentState.area = area;

                Vendd.MessageBus.publishAsync(wrapper, new Vendd.Store.Messages.SetArea(area));
            });
        };
        //$('.x-store-locator .form-row .select-wrapper select').sSelect();
        stores.loading = function (loading) {
            if (loading) {
                $stores.addClass('x-loading');
            } else {
                $stores.removeClass('x-loading');
            };
        };

        stores.bind = function () {
            var $slider = $('.x-slider', $stores),
                $list = $('.x-partner-list', $stores),
                $partners = $('.x-partner-box', $list),
                coordinates = [];

            if ($list.length === 0 || $partners.length === 0) {
                return;
            }
            $.each($partners, function (i, partner) {
                var $partner = $(partner),
                    coord = {
                        title: $partner.data('name'),
                        lat: $partner.data('latitude'),
                        lng: $partner.data('longitude'),
                        html: $('.box-info', $partner).html()
                    };

                if (coord.lat !== '' && coord.lng !== '') {
                    coordinates.push(coord);
                };
            });

            if (map && map.markers && map.markers.length > 0) {
                map.removeMarkers();
                map.addMarkers(coordinates);
            } else {
                if (map && typeof map.create === 'function') {
                    if (coordinates.length > 0) {
                        map.create(coordinates);
                    };
                }
            };
        };

        stores.update = function () {
            var html = Vendd.Handlebars.parse("storeLocatorStores", storemodel);

            $stores.html(html);

            stores.bind();

            state = $.extend(true, {}, currentState);

            form.propButton();

            stores.loading(false);
        };

        $form.on('change', 'select[name="continent"]', function (e) {
            form.loading(true);

            var continent = $(this).val();

            currentState.continent = continent;

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Store.Messages.SetContinent(continent));
        });

        $form.on('change', 'select[name="country"]', function (e) {
            form.loading(true);

            var country = $(this).val();

            currentState.country = country;

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Store.Messages.SetCountry(country));
        });

        $('.x-store-locator-form select[name="city"]').change(function (e) {
            form.loading(true);

            var city = $(this).val();

            currentState.city = city;

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Store.Messages.SetCity(city));

        });

        $('.x-store-locator-form select[name="area"]').change(function (e) {
            form.loading(true);

            var area = $(this).val();

            currentState.area = area;

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Store.Messages.SetArea(area));
        });

        $form.on('change', 'input[name="type"]', function (e) {
            form.loading(true);

            var type = parseInt($('input[name="type"]:checked').val(), 10);

            currentState.type = type;

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Store.Messages.SetType(type));
        });

        $form.on('keyup', 'input[name="postalCode"]', function (e) {
            e.stopPropagation();

            var $this = $(this);

            if (e.keyCode == 13) {
                e.preventDefault();

                currentState.postalCode = $this.val();

                $submitButton.click();
            } else {
                currentState.postalCode = $this.val();

                form.propButton();
            };
        });

        $form.on('keyup', 'input[name="search"]', function (e) {
            e.stopPropagation();

            var $this = $(this);

            if (e.keyCode == 13) {
                e.preventDefault();

                currentState.search = $this.val();

                $submitButton.click();
            } else {
                currentState.search = $this.val();

                form.propButton();
            };
        });

        $form.on('click', '.js-reset', function (e) {
            e.preventDefault();
            e.stopPropagation();

            form.loading(true);

            form.reset();
        });

        $form.on('click', '.js-submit', function (e) {
            e.preventDefault();
            e.stopPropagation();

            stores.loading(true);

            form.submit();
        });

        $(".newList", $wrapper).mCustomScrollbar({
            scrollbarPosition: "outside",
            scrollInertia: 400,
            theme: "dark-2",
            mouseWheel: { preventDefault: true }
        });

        $(".x-store-locator .x-partner-list", $wrapper).mCustomScrollbar({
            scrollbarPosition: "outside",
            scrollInertia: 400,
            theme: "dark-2",
            mouseWheel: { preventDefault: true }
        });

        $stores.on('click', '.x-partner-box', function (e) {
            if (e.target.href) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this),
                coords, marker;

            coords = {
                title: $this.data('name'),
                lat: $this.data('latitude'),
                lng: $this.data('longitude')
            };

            marker = $map.get(0).getMarker(coords);

            if (marker) {
                $map.get(0).open(marker);

                $('html, body').animate({
                    scrollTop: $map.offset().top - 50
                }, 500);
            };
            $('.x-partner-box').removeClass('selected');
            $(this).addClass('selected');
            $(".map-partner-box .x-partner-box").remove();
            $(this).clone().appendTo(".map-partner-box");
        });

        $stores.on('click', '.js-more', function (e) {
            e.stopPropagation();
        });

        $wrapper.on('click', '.js-back-to-stores', function (e) {
            e.preventDefault();
            e.stopPropagation();

            $('html, body').animate({
                scrollTop: $('.inner-area-two > .title-container').offset().top - 10
            }, 500);
        });

        return true;
    };

    Vendd.MessageBus.subscribe(Vendd.Store.Messages.UpdateForm, wrapper, function (envelope) {
        formmodel = envelope.message.data.model;
        form.update();
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Store.Messages.Refine(currentState));
    });
    Vendd.MessageBus.subscribe(Vendd.Store.Messages.UpdateStores, wrapper, function (envelope) {
        storemodel = envelope.message.data.model;
        stores.update();
    });
    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.GoogleMapsLoaded, 'storesMap', function () {
        if (run() && isElementInViewport($wrapper) && !$wrapper.hasClass('loaded')) {
            form.bind();
            stores.bind();
            $wrapper.addClass('loaded');
        } else {
            $(window).on('scroll resize', function () {
                if (run() && isElementInViewport($wrapper) && !$wrapper.hasClass('loaded')) {
                    form.bind();
                    stores.bind();
                    $wrapper.addClass('loaded');
                }
            });
        }
    });


});